export default __webpack_public_path__ + "static/media/emp_card.80a048dd.svg";